import { useMutation, useQueryClient } from '@tanstack/react-query';

import ReservationService from '~/services/ReservationService';

import { amenityQueryKeys } from './amenityQueryKeys';

interface CreateAmenityGroupData {
  name: string;
}

export function useCreateAmenityGroup() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ name }: CreateAmenityGroupData) => {
      return await ReservationService.createAmenityGroup(name);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: amenityQueryKeys.all });
    },
  });
}
